export default (function (_ref) {
  var request = _ref.request;
  return {
    cycleWarnAdd: function cycleWarnAdd(data) {
      return request({
        url: '/disease/cycleWarn/add',
        method: 'post',
        data: data
      });
    },
    cycleWarnModify: function cycleWarnModify(data) {
      return request({
        url: "/disease/cycleWarn/".concat(data.id, "/modify"),
        method: 'put',
        data: data
      });
    },
    cycleWarnDel: function cycleWarnDel(id) {
      return request({
        url: "/disease/cycleWarn/".concat(id, "/del"),
        method: 'delete'
      });
    },
    cycleWarnQuery: function cycleWarnQuery(data) {
      return request({
        url: '/disease/cycleWarn/query',
        method: 'get',
        params: data
      });
    },
    cycleWarnDetail: function cycleWarnDetail(id) {
      return request({
        url: "/disease/cycleWarn/".concat(id, "/detail"),
        method: 'get'
      });
    }
  };
});